// Helpers visuais compartilhados — badges de status / classificação / origem.
import type { ContaAPagar, ClassificacaoStatus, StatusConta, PlanoConta } from '../types';

export interface CategoriaOption { id: number; label: string }

// Constrói as opções de categoria (nível 3) com caminho "Classe › Departamento › Categoria".
export function buildCategoriaOptions(items: PlanoConta[]): CategoriaOption[] {
  const byId = new Map(items.map((p) => [p.id, p]));
  return items
    .filter((p) => p.nivel === 3 && p.ativo)
    .map((cat) => {
      const dep = cat.parent_id ? byId.get(cat.parent_id) : undefined;
      const cla = dep?.parent_id ? byId.get(dep.parent_id) : undefined;
      const label = [cla?.nome, dep?.nome, cat.nome].filter(Boolean).join(' › ');
      return { id: cat.id, label };
    })
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
}

export const HOJE = new Date().toISOString().slice(0, 10);

// Badge de status da conta (considera atraso).
export function statusBadge(c: Pick<ContaAPagar, 'status' | 'vencimento' | 'tipo'>): { label: string; cls: string } {
  const atrasada = c.status !== 'pago' && !!c.vencimento && c.vencimento < HOJE;
  if (atrasada) return { label: 'Atrasada', cls: 'atrasada' };
  const map: Record<StatusConta, { label: string; cls: string }> = {
    pendente:   { label: 'Pendente', cls: 'pendente' },
    aguardando: { label: 'Aguardando', cls: 'aguardando' },
    pago:       { label: c.tipo === 'receita' ? 'Recebido' : 'Pago', cls: 'pago' },
  };
  return map[c.status] ?? { label: c.status, cls: 'neutro' };
}

export function classifBadge(cls: ClassificacaoStatus): { label: string; cls: string } {
  const map: Record<ClassificacaoStatus, { label: string; cls: string }> = {
    pendente:   { label: 'Pendente', cls: 'neutro' },
    sugerida:   { label: 'Sugerida', cls: 'pendente' },
    auto:       { label: 'Auto', cls: 'aguardando' },
    confirmada: { label: 'Confirmada', cls: 'pago' },
  };
  return map[cls] ?? { label: cls, cls: 'neutro' };
}

// Caminho da categoria "Classe › Departamento › Categoria"
export function catPath(c: Pick<ContaAPagar, 'classe' | 'departamento' | 'categoria'>): string {
  const parts = [c.classe, c.departamento, c.categoria].filter(Boolean);
  return parts.length ? parts.join(' › ') : '—';
}
export function catPathSugerida(c: Pick<ContaAPagar, 'classe_sugerida' | 'departamento_sugerido' | 'categoria_sugerida'>): string {
  const parts = [c.classe_sugerida, c.departamento_sugerido, c.categoria_sugerida].filter(Boolean);
  return parts.length ? parts.join(' › ') : '';
}
